// reducers/eventReducer.js
import {
    FETCH_EVENTS_REQUEST,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAILURE,
    CREATE_EVENT_REQUEST,
    CREATE_EVENT_SUCCESS,
    CREATE_EVENT_FAILURE,
    DELETE_EVENT_REQUEST,
    DELETE_EVENT_SUCCESS,
    DELETE_EVENT_FAILURE,
    UPDATE_EVENT_REQUEST,
    UPDATE_EVENT_SUCCESS,
    UPDATE_EVENT_FAILURE,
  } from '../actions/eventActions';
  
  // Initial State
  const initialState = {
    loading: false,
    events: { data: [] },
    error: '',
    eventCreated: false,
  };
  
  // Event Reducer
  const eventReducer = (state = initialState, action) => {
    switch (action.type) {
      // Fetching Events
      case FETCH_EVENTS_REQUEST:
        return {
          ...state,
          loading: true,
          eventCreated: false,
        };
      case FETCH_EVENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          events: action.payload,
          error: '',
        };
        
      case FETCH_EVENTS_FAILURE:
        return {
          ...state,
          loading: false,
          events: [],
          error: action.payload,
        };
  
      // Creating Event
      case CREATE_EVENT_REQUEST:
        return {
          ...state,
          loading: true,
          eventCreated: false,
        };
      case CREATE_EVENT_SUCCESS:
        return {
          ...state,
          loading: false,
          events: [...state.events, action.payload], // Add the newly created event to the state
          eventCreated: true,
          error: '',
        };

        
      case CREATE_EVENT_FAILURE:
        return {
          ...state,
          loading: false,
          eventCreated: false,
          error: action.payload,
        };
      
        // Deleting Event
    case DELETE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        events: {
          ...state.events,
          data: state.events.data.filter(event => event.event_id !== action.payload), // Remove the deleted event from the state
        },
        error: '',
      };
    case DELETE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Updating Event
    case UPDATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        events: {
          ...state.events,
          data: state.events.data.map(event =>
            event.event_id === action.payload.event_id ? action.payload : event
          ), // Update the modified event in the state
        },
        error: '',
      };
    case UPDATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
  
      default:
        return state;
    }
  };  
  
  export default eventReducer;
  